export const APP_VERSION = '0.1.1';
export const BUILD_DATE = '2026-06-29T09:09:21Z';
export const COMMIT_HASH = '66b04d6f';
export const BUILD_DATE_UTC = '2026-06-29T09:09:21Z';
export const BUILD_DATE_IST = '2026-06-29T14:39:21+05:30';
export const ENVIRONMENT = 'stage';
